/**
 * ? @description : Primary Information Component
 */

// Dependencies
import React from "react";
import { Form } from "react-bootstrap";

export default function PrimaryInfo({
  formData,
  setFormData,
  validationRes,
  setValidationRes,
}) {
  return (
    <div>
      <Form>
        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Name <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="name"
            name="teacher_name"
            placeholder="Enter Your Name"
            // style={{ width: "250px" }}
            value={formData.teacher_name}
            onChange={(event) => {
              setFormData({ ...formData, teacher_name: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherName: false,
                isInvalidTeacherNameFormate:false,
              });
            }}
            isInvalid={validationRes.isInvalidTeacherName || validationRes.isInvalidTeacherNameFormate}
          />
          <Form.Text>Note:- The name cannot exceed 50 characters</Form.Text>

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherName? 'Name is mandatory and should be less than 50 characters.':''}
            {validationRes.isInvalidTeacherNameFormate ? 'The volunteer name name should consist only of alphabetical values.':''}
           
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Mobile Number <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="tel"
            name="contactno"
            placeholder="Enter Your Number"
            // style={{ width: "250px" }}
            value={formData.contactno}
            onChange={(event) => {
              setFormData({ ...formData, contactno: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMobileNumber: false,
                isInvalidTeacherMobileNumberFormate:false,
              });
            }}
            isInvalid={validationRes.isInvalidTeacherMobileNumber || validationRes.isInvalidTeacherMobileNumberFormate}
          />

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherMobileNumber ?'Mobile number must contains 10 digits.' :''}
        {validationRes.isInvalidTeacherMobileNumberFormate ? 'Volunteer phone number is not valid':''}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Email ID <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="email"
            name="email"
            placeholder="Your Email Id"
            // style={{ width: "250px" }}
            value={formData.email}
            onChange={(event) => {
              setFormData({ ...formData, email: event.target.value.toLocaleLowerCase() });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMailId: false,
              });
            }}
            isInvalid={validationRes.isInvalidTeacherMailId}
          />

          <Form.Control.Feedback type="invalid">
            Enter valid Email Id
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Spoken Language - 1 <span style={{ color: "red" }}>*</span>
          </Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_1"
            placeholder="First Language"
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          /> */}

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>

          <Form.Control.Feedback type="invalid">
            Spoken Language is mandatory.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 2</Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_2"
            placeholder="Second Language"
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage2: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage2}
          /> */}

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 3</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_3}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_3: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 4</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_4}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_4: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 5</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_5}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_5: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 6</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_6}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_6: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Kannada">Kannada</option>
            <option value="Malayalam">Malayalam</option>
            <option value="Tamil">Tamil</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdu">Urdu</option>

          </Form.Select>
        </Form.Group>
      </Form>
    </div>
  );
}
